/*
 * Copyright (c) 2025 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { createAction } from "@reduxjs/toolkit";

export const resetStore = createAction("store/reset");
